import Box from '@mui/material/Box';
import P from '../Reusables/Typography/P'
import BulletSpan from './BulletSpan';
import LargerHeading from './LargerHeading';

const Organisers = () => {
    return (
        <Box 
            className="m-2 mt-6 ml-4 mr-4 f-size_2" 
            color={'grey'}
            sx={{
                fontSize: 12,
                '& .MuiTypography-root': {
                    width: '100%'
                }
            }}
        >
            <P>
                We collaborate with organizers across the UK. If you're not yet working with Exhibit Hire, why not give us the chance to demonstrate what we can offer? Here's why stand organizers choose us:
            </P>
            <BulletSpan number={1} text="Discounted pricing" />

            <P>
                We provide significant discounts exclusively for organizers. Register an account on our website, and within 24 hours, we'll apply your personalized discount level so you can view tailored pricing while browsing.
            </P>

            <BulletSpan number={3} text="Nationwide coverage" />
            <P>
                We deliver to all major exhibition centres, including London Olympia, ExCeL, and NEC Birmingham. Wherever your exhibition is, we've got you covered.
            </P>

            <BulletSpan number={4} text="Exhibition experts" />
            <P>
                As our name implies, exhibitions are our specialty. With extensive experience at major venues, our logistics team ensures your furniture is delivered and collected at the right time, by the right team, using the right equipment.
            </P>

            <BulletSpan number={5} text="Hassle-free online booking" />
            <P>
                Our website makes furniture rental effortless. Choose your items, enter the show details, and complete your booking in just a few clicks. Log in to view invoices, upcoming deliveries, and collection schedules.
            </P><br/>

            <P>
                Prefer to speak to someone? Our friendly account managers are always available to assist on <a href={`tel:02033840369`} className="link">0203 384 0369</a>.
            </P>
            
            <BulletSpan number={6} text="Visit our showroom"/>
            <P>
                Explore our 5,000 sq ft showroom at our South East London headquarters near the Dartford Crossing. Book a visit or a warehouse tour. Get in touch, we'll be happy to welcome you. Let us help make your next exhibition a success!
            </P>
            <br/>
           
            <LargerHeading>
                Want to work with us:
            </LargerHeading>

            <P>
                There are several ways to start working with us!
            </P>

            <ul>
                <li>
                    Register as a organiser on our website.
                </li>
                <li>
                    Call one of our account managers on <a href={`tel:02033840369`} className="link">0203 384 0369</a>
                </li>
                <li>
                    Email us:  <a href={`mailto:sales@exhibithire.co.uk`} className="link">sales@exhibithire.co.uk</a>
                </li>
                {/* <li>
                    Whatsapp us:  <a href={`tel:07XXXXXXXXX`} className="link">07XXXXXXXXX</a>
                </li> */}
            </ul>
            <br/>

            <LargerHeading>
                Want to know more?
            </LargerHeading>
            <P>
                To find out more about our company and our history visit our about us page.
            </P>

        </Box>
    )
}

export default Organisers